import { axiosInstance } from 'app/utils/axiosConfig'
import { User } from 'EstraSponsor'

import { endpoints } from './endpoints'

export type ConfirmUserPayload = {
  confirmation_token: string
}

export type ConfirmUserResponse = User

export const confirmUser = async (
  data: ConfirmUserPayload
): Promise<ConfirmUserResponse> => {
  return axiosInstance.get(endpoints.confirmUser, {
    params: { confirmation_token: data.confirmation_token },
  })
}
